// Remove 'no-js' class from <html> if JS is enabled
document.documentElement.classList.remove("no-js");

//
// PRODUCT VIDEO - PRODUCT PAGE
//

// Function to add the attributes if they are not already present on <video-media>
function checkAndAddAttributes(videoMediaElement) {
  // The permanent Slider video-first hero has its own poster, buffering and autoplay lifecycle. The legacy helper
  // below force-reloads every gallery video after window.load, which used to tear down the first
  // decoded Slider frame and expose the gallery background on cold Safari navigations.
  if (videoMediaElement.hasAttribute("data-pkm-slider-controlled-video") || videoMediaElement.hasAttribute("data-pkm-mercury-autoplay")) {
    return;
  }

  if (!videoMediaElement.hasAttribute("loaded")) {
    videoMediaElement.setAttribute("loaded", "");
  }
  if (!videoMediaElement.hasAttribute("can-play")) {
    videoMediaElement.setAttribute("can-play", "");
  }
  if (!videoMediaElement.hasAttribute("playing")) {
    videoMediaElement.setAttribute("playing", "");
  }

  // Ensure the video starts at the first frame
  const videoElement = videoMediaElement.querySelector("video");
  if (videoElement) {
    // Use the loadeddata event to ensure the first frame is loaded
    videoElement.addEventListener("loadeddata", () => {
      videoElement.currentTime = 0;
    });

    // Add an event listener to force the video to start at time 0
    videoElement.addEventListener("play", () => {
      if (videoElement.currentTime > 0) {
        videoElement.pause(); // Pause the video
        videoElement.currentTime = 0; // Reset to the first frame
        videoElement.play(); // Play the video again
      }
    });

    // Preload the video more aggressively
    videoElement.setAttribute("preload", "auto");
  }
}

// Function to monitor video-media elements within .product-gallery__media
function monitorVideoMediaElements() {
  const videoMediaElements = document.querySelectorAll(
    ".product-gallery__media video-media"
  );

  videoMediaElements.forEach((videoMediaElement) => {
    checkAndAddAttributes(videoMediaElement);
  });
}

// Function to check if the document is fully loaded
function checkIfFullyLoaded() {
  if (document.readyState === "complete") {
    monitorVideoMediaElements();

    // Monitor when new video-media elements are dynamically added to the DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          monitorVideoMediaElements();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    requestAnimationFrame(checkIfFullyLoaded);
  }
}

// Function to check if the device is desktop
function isDesktop() {
  return window.innerWidth >= 1000; // You can adjust this width value as needed
}

// Start checking if the page is fully loaded after the window's load event, only on desktop
window.addEventListener("load", () => {
  if (isDesktop()) {
    requestAnimationFrame(checkIfFullyLoaded);
  }
});

// Function to ensure the necessary attributes are added and trigger play
function handleVideoAttributesAndPlaybackForSafari(videoMediaElement) {
  // Do not let the legacy Safari workaround reload the controlled Slider video-first hero.
  if (videoMediaElement.hasAttribute("data-pkm-slider-controlled-video") || videoMediaElement.hasAttribute("data-pkm-mercury-autoplay")) {
    return;
  }

  if (!videoMediaElement.hasAttribute("loaded")) {
    videoMediaElement.setAttribute("loaded", "");
  }
  if (!videoMediaElement.hasAttribute("can-play")) {
    videoMediaElement.setAttribute("can-play", "");
  }

  const videoElement = videoMediaElement.querySelector("video");
  if (videoElement) {
    const playVideo = () => {
      videoElement.load(); // Force reload the video every time
      videoElement.play().catch(() => {
        console.warn("Video play was prevented by Safari autoplay policy");
      });
      videoMediaElement.setAttribute("playing", "");
    };

    // Ensure video plays when the element is selected
    if (videoMediaElement.closest(".is-selected")) {
      playVideo();
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          if (videoMediaElement.classList.contains("is-selected")) {
            playVideo(); // Reload and play the video again
          } else {
            videoElement.pause();
            videoMediaElement.removeAttribute("playing");
          }
        }
      });
    });

    observer.observe(videoMediaElement, { attributes: true });
  }
}

// Function to handle video playback on Safari for small screens
function handleSafariVideoPlayback() {
  const videoMediaElements = document.querySelectorAll(
    ".product-gallery__media video-media"
  );

  videoMediaElements.forEach((videoMediaElement) => {
    handleVideoAttributesAndPlaybackForSafari(videoMediaElement);
  });
}

// Function to check if the browser is Safari on a screen width below 1000px
function isSafariOnSmallScreen() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return isSafari && window.innerWidth < 1000;
}

// Start checking if the page is fully loaded after the window's load event for Safari on small screens
window.addEventListener("load", () => {
  if (isSafariOnSmallScreen()) {
    requestAnimationFrame(handleSafariVideoPlayback);
  }
});

//
// Prose section toggle - Collection page and Product page
//


/* Re-worked collapse feature */
// window.addEventListener("load", function () {
//   const excludedUrls = [
//     "https://varmbakken.shop/collections/gaver",
//     "https://varmbakken.shop/collections/smykker",
//   ];

//   const url = window.location.href.split("?")[0];
//   if (excludedUrls.includes(url)) {
//     console.log("Script disabled on this page.");
//     return;
//   }

//   function addReadMoreIfNeeded(selector) {
//     const element = document.querySelector(selector);
//     element.classList.remove("start");
//     if (!element || document.getElementById('toggle-prose')) return;

//     const visibleChildren = Array.from(element.children).filter((child) => {
//       const style = getComputedStyle(child);
//       return style.display !== 'none' && 
//              child.offsetHeight > 0 && 
//              child.getBoundingClientRect().width > 0;
//     });

//     // if (visibleChildren.length <= 2) {
//     //   element.classList.add("no-gradient");
//     //   return;
//     // } else {
//     //   element.classList.add("gradient");
//     // }

//     setTimeout(() => {
//       const styles = getComputedStyle(element);
//       const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.2;
//       const elementHeight = element.getBoundingClientRect().height;

//       if (elementHeight > lineHeight * 2 && document.querySelector('#toggle-prose') === null) {
//         const readMoreButton = document.createElement("button");
//         readMoreButton.innerHTML = `
//           <svg class="icon h-12 w-12" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M4.8125 7.90625L11 14.0938L17.1875 7.90625" stroke="#272219" stroke-width="1.5" stroke-linecap="square"/>
//           </svg>
//         `;
//         readMoreButton.id = "toggle-prose";

//         element.parentNode.insertBefore(readMoreButton, element.nextSibling);

//         readMoreButton.addEventListener("click", () => {
//           element.classList.toggle("expanded");
//           const icon = readMoreButton.querySelector("svg");
//           icon.style.transform = element.classList.contains("expanded")
//             ? "rotate(180deg)"
//             : "rotate(0deg)";
//         });
//       }
//     }, 100);
//   }

  
//   setTimeout(() => {
//     addReadMoreIfNeeded(".collection-header .prose");
//     addReadMoreIfNeeded(".product-info__accordion .accordion__content .prose");
//   }, 500);
// });

/*

// Lavet af Janus



/* Tilmeld nyhedsbrev*/
// Check if the current URL matches the specific page URL
if (window.location.pathname === "/pages/tilmeld-nyhedsbrev") {
  window.onscroll = function () {
    const button = document.getElementById("sticky-button");
    if (window.scrollY > 300) {
      // Show the button after 300px of scrolling
      button.style.display = "block";
    } else {
      button.style.display = "none";
    }
  };
}

// document.addEventListener("DOMContentLoaded", function () {
//   const productForms = document.querySelectorAll(
//     'form[action="/cart/add"][is="product-form-gift"]'
//   );

//   productForms.forEach((form) => {
//     form.addEventListener("submit", async function (e) {
//       e.preventDefault();

//       const submitButton = form.querySelector('button[type="submit"]');
//       const originalText = submitButton.innerHTML;

//       submitButton.disabled = true;
//       submitButton.innerHTML =
//         "<div>Adding...</div>" +
//         submitButton.querySelector(".button__loader").outerHTML;

//       try {
//         const formData = new FormData(form);
//         const response = await fetch("/cart/add", {
//           method: "POST",
//           body: formData,
//         });

//         if (!response.ok) {
//           throw new Error("Failed to add product to cart");
//         }

//         // Получаем актуальное состояние корзины
//         const cartResponse = await fetch("/cart.js");
//         const cartData = await cartResponse.json();

//         // Отправляем событие с новыми данными корзины
//         document.dispatchEvent(
//           new CustomEvent("cart:change", {
//             detail: { cart: cartData },
//           })
//         );
//       } catch (error) {
//         console.error("Error:", error);
//       } finally {
//         submitButton.disabled = false;
//         submitButton.innerHTML = originalText;
//       }
//     });
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  const productForms = document.querySelectorAll(
    'form[action="/cart/add"][is="product-form-gift"]'
  );

  productForms.forEach((form) => {
    form.addEventListener("submit", async function (e) {
      e.preventDefault();

      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton.innerHTML;

      submitButton.disabled = true;
      submitButton.innerHTML =
        "<div>Adding...</div>" +
        submitButton.querySelector(".button__loader").outerHTML;

      try {
        const formData = new FormData(form);
        const response = await fetch("/cart/add", {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          throw new Error("Failed to add product to cart");
        }

        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        const sectionsResponse = await fetch(
          `${window.Shopify.routes.root}?section_id=cart-drawer`
        );
        const sectionsText = await sectionsResponse.text();
        const sectionsDom = new DOMParser().parseFromString(
          sectionsText,
          "text/html"
        );
        const cartDrawerSection = sectionsDom.getElementById("cart-drawer");

        const drawerElement = document.getElementById("cart-drawer");
        if (drawerElement) {
          drawerElement.innerHTML = cartDrawerSection.innerHTML;
          drawerElement.classList.add("is-open");
          document.body.classList.add("cart-open");
        }

        document.dispatchEvent(
          new CustomEvent("cart:change", {
            detail: { cart: cartData },
          })
        );
        document.dispatchEvent(
          new CustomEvent("cart:afterUpdate", {
            detail: { cart: cartData },
          })
        );
      } catch (error) {
        console.error("Error:", error);
      } finally {
        submitButton.disabled = false;
        submitButton.innerHTML = originalText;
      }
    });
  });
});
if (/Android/i.test(navigator.userAgent)) {
  document.body.classList.add("android");
}

// document.addEventListener("DOMContentLoaded", function () {
//   let wishlist = [];

//   try {
//     wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
//   } catch (e) {
//     console.error("Failed to parse wishlist", e);
//     localStorage.removeItem("wishlist");
//   }

//   document.querySelectorAll(".wishlist-button").forEach((button) => {
//     const id = button.dataset.productId;
//     const svg = button.querySelector(".wish-svg");

//     // Update button state
//     const updateButtonState = (isActive) => {
//       button.classList.toggle("active", isActive);
//       if (svg) {
//         svg.style.fill = isActive ? "#000" : "";
//       }
//     };

//     // Initialize
//     updateButtonState(wishlist.includes(id));

//     // Click handler
//     button.addEventListener("click", () => {
//       const index = wishlist.indexOf(id);
//       const isAdding = index === -1;

//       if (isAdding) {
//         wishlist.push(id);
//       } else {
//         wishlist.splice(index, 1);
//       }

//       updateButtonState(isAdding);
//       localStorage.setItem("wishlist", JSON.stringify(wishlist));
//     });
//   });
// });

const ids = [
  "ov-onskeskyen-generated-wish-button",
  "gowishRoundedButton",
  "gowishBlueButton2",
  "gowishBlueButton",
  "gowishWhiteButton",
  "gowishDynamicButton",
];

const GOWISH_SCRIPT_ID = "gowish-iframescript"; // script should be imported with this id
const GOWISH_REGION_ATTR_NAME = "data-region"; // region attribute name - optional
const GOWISH_PRODUCT_URL_ATTR_NAME = "data-producturl"; // product url attribute name - optional
const GOWISH_ENV_ATTR_NAME = "data-env"; // dev, staging, prod
const GOWISH_USE_BTN_REGION = "data-use-btn"; // use btn attribute name - optional
const GOWISH_IFRAME_ID = "gowish-iframe"; // id iframe created by this script
const GOWISH_DIALOG_ID = "gowish-iframe-dialog"; // id of dialog created by this script

let isLoggingInWithSocial = false;
document.addEventListener(
  "click",
  function (e) {
    console.log("Global click:", e.target);
  },
  true
); // Используем capture phase
// Adds click eventlistener for opening the iframe
document.addEventListener(
  "click",
  function (e) {
    const el = e.target; // ловим клики и на кнопках, и на ссылках
    console.log(el);
    if (!el) return;

    const baseId = el.id?.replace(/\d+$/, ""); // удаляем числовой суффикс
    const hasValidId = baseId && ids.includes(baseId);
    const hasGowishClass = el.classList.contains("gowish-button2"); // тут можно добавить свои классы

    if (hasValidId || hasGowishClass) {
      const script = document.getElementById(GOWISH_SCRIPT_ID);
      let region = script?.getAttribute(GOWISH_REGION_ATTR_NAME) || "denmark";
      let targetUrl = el.getAttribute("data-producturl");

      if (script?.getAttribute(GOWISH_USE_BTN_REGION)) {
        region = el.getAttribute(GOWISH_REGION_ATTR_NAME) || region;
      }
      const prodUrl = el.getAttribute("data-producturl");
      console.log(prodUrl);
      if (targetUrl && URL.canParse(targetUrl)) {
        createIframe(region, targetUrl);
      } else if (el.classList.contains("gowish-button2")) {
        createIframe(region, `https://varmbakken.shop${prodUrl}`);
      } else {
        createIframe(region, window.location.href);
      }
    }
  },
  true
);

// Adds message eventlistener for onClose
window.addEventListener(
  "message",
  (event) => {
    if (event.data === "onClose") {
      const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
      if (dialogElement) {
        document.body.removeChild(dialogElement);
      }
    }
  },
  false
);

function getUrlBase() {
  const script = document.getElementById(GOWISH_SCRIPT_ID);
  const env = script?.getAttribute(GOWISH_ENV_ATTR_NAME) ?? "prod";

  switch (env) {
    case "local":
      return {
        ROOT_DK: "http://localhost:3000",
        ROOT_NO: "http://localhost:3000",
        ROOT_GLOBAL: "http://localhost:3000",
      };
    case "dev":
      return {
        ROOT_DK: "https://dev.onskeskyen.dk",
        ROOT_NO: "https://dev.onskeskyen.no",
        ROOT_GLOBAL: "https://dev.gowish.com",
      };
    case "staging":
      return {
        ROOT_DK: "https://staging.onskeskyen.dk",
        ROOT_NO: "https://staging.onskeskyen.no",
        ROOT_GLOBAL: "https://staging.gowish.com",
      };
    case "prod":
    default:
      return {
        ROOT_DK: "https://onskeskyen.dk",
        ROOT_NO: "https://onskeskyen.no",
        ROOT_GLOBAL: "https://gowish.com",
      };
  }
}

// Returns iframe src url for a given region + encoded crawlertarget
function getIframeSrc(region, encodedPath) {
  const { ROOT_GLOBAL, ROOT_NO, ROOT_DK } = getUrlBase();
  const path = `/quick-add?source=button&crawlerTarget=${encodedPath}`;

  switch (region) {
    case "global":
      return ROOT_GLOBAL + path;
    case "norway":
      return ROOT_NO + path;
    default:
      return ROOT_DK + path; // Defaults to Denmark
  }
}

// Get scheme based on region
// region can be: "global", "denmark" or "norway"
const getScheme = (region) => {
  if (region === "global") {
    return "gowish://";
  }

  return "onskeskyen://";
};

// Creates the iframe
function createIframe(region, targetUrl) {
  try {
    // Construct encoded path for product
    const params = new URLSearchParams(window.location.search);
    const uri =
      targetUrl || params.get("crawlerTarget") || window.location.href;
    const encoded = encodeURIComponent(uri);

    // Check if this is a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      const scheme = getScheme(region);

      const url = `${scheme}quick-add?source=button&crawlerTarget=${encoded}`;
      window.location.href = url;

      window.addEventListener("message", (event) => {
        const hasType =
          typeof event.data === "object" &&
          Boolean(event.data) &&
          "type" in event.data;
        const type =
          hasType && typeof event.data.type === "string"
            ? event.data.type
            : undefined;
        if (type === "gowish_iframe_open_popup") {
          const authUrls = [
            "https://auth.gowish.com/",
            "https://auth.dev.gowish.com/",
            "https://auth.staging.gowish.com/",
          ];

          // Ensure url is auth url
          if (
            !authUrls.some((authUrl) => event?.data?.url.startsWith(authUrl))
          ) {
            return;
          }

          // Prevent closing iframe when returning to page
          isLoggingInWithSocial = true;
        }
      });

      // Close iframe if return to page
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          if (isLoggingInWithSocial) {
            isLoggingInWithSocial = false;
          } else {
            const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
            if (dialogElement) {
              document.body.removeChild(dialogElement);
            }
          }
        }
      });
    }

    const iframe = document.getElementById(GOWISH_IFRAME_ID);
    if (iframe) {
      // Close iframe if already opened
      const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
      if (dialogElement) {
        document.body.removeChild(dialogElement);
      }
    } else {
      // Get iframe src
      const iframeSrc = getIframeSrc(region, encoded);

      // Create a modal
      const modal = document.createElement("dialog");
      modal.setAttribute("class", "gowish-dialog");
      modal.setAttribute("id", GOWISH_DIALOG_ID);

      // styling the modal
      const style = document.createElement("style");
      style.setAttribute("type", "text/css");
      const css = `
        .gowish-dialog {          
          background-color:rgba(0, 153, 187, 0.45);
          border-width:0;
          min-width:100%;
          min-height:100%;
          width:100%;
          height:100%;
          text-align:center;
          top:20px;
        }
        @media screen and (min-width: 768px) {
          .gowish-dialog {
            display:flex;
            justify-content:center;
            align-items:center;
            top:0;
          }
        }
      `;
      style.innerHTML = css;
      document.head.appendChild(style);

      modal.addEventListener("click", () => {
        const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
        if (dialogElement) {
          document.body.removeChild(dialogElement);
        }
      });

      // Add iframe as a child to the modal
      modal.innerHTML = `
        <div id="modal-container" onclick="(e)=>{e.stopPropagation();e.preventDefault();}" class="gowish-modal-container" style="width:100%">
          <iframe
            id="${GOWISH_IFRAME_ID}"
            src="${iframeSrc}" 
            class="gowish-iframe"
            style="height:780px;border:none;margin:0 auto;padding:0;overflow:hidden;border-radius:30px;width:100%;max-width:824px;"
          />
        </div>
      `;

      // Append modal to the body
      document.body.appendChild(modal);

      // Show the modal
      const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
      if (dialogElement instanceof HTMLDialogElement) {
        dialogElement.showModal();
      }
    }
  } catch (err) {
    console.error(err);
  }
}

// Fix mobile sort function not working in theme
(function () {
  function applySort(val) {
    if (!val) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', val);
    url.searchParams.delete('page'); // avoid stale pagination when switching sort
    location.assign(url.toString());
  }

  // Listen to the custom event the listbox emits
  document.addEventListener('listbox:select', (e) => {
    const val = e.detail?.value
      || e.detail?.option?.getAttribute?.('value')
      || e.detail?.selected?.getAttribute?.('value')
      || e.target?.closest?.('.popover-listbox__option[role="option"][value]')?.getAttribute('value');
    applySort(val);
  }, { capture: true });

  // Safety net: direct click handler in case the custom event changes
  document.addEventListener('click', (e) => {
    const btn = e.target?.closest('.popover-listbox__option[role="option"][value]');
    if (!btn) return;
    applySort(btn.getAttribute('value'));
  }, { capture: true });
})();

// Gift wrap: after expand, scroll gift-set block into view (minimal scroll, block: nearest)
(function () {
  const GIFT_WRAP_EXPAND_MS = 400;

  document.addEventListener("change", function (e) {
    const checkbox = e.target;
    if (!checkbox.matches || !checkbox.matches(".gift-wrap-toggle__checkbox")) return;
    if (!checkbox.checked) return;

    const block = checkbox.closest(".gift-wrap-block");
    if (!block) return;

    const target = block.querySelector(".gift-set-suggestion--in-gift-wrap");
    if (!target) return;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    window.setTimeout(function () {
      target.scrollIntoView({
        behavior: reducedMotion ? "auto" : "smooth",
        block: "nearest",
      });
    }, GIFT_WRAP_EXPAND_MS);
  });
})();

// Gift set suggestion: add current variant + complementary product (PKM metafields; discount via Admin)
(function () {
  document.addEventListener(
    "click",
    async function (e) {
      const btn = e.target.closest("[data-gift-set-add]");
      if (!btn) return;
      e.preventDefault();
      const mainId = parseInt(btn.dataset.mainVariantId, 10);
      const sugId = parseInt(btn.dataset.suggestionVariantId, 10);
      if (!mainId || !sugId) return;

      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      btn.setAttribute("disabled", "disabled");
      btn.setAttribute("aria-busy", "true");

      try {
        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
              items: [
                { id: mainId, quantity: 1 },
                { id: sugId, quantity: 1 },
              ],
              sections: sectionsToBundle.join(","),
              sections_url: window.location.pathname,
            }),
          }
        );
        const responseJson = await response.json();
        if (!response.ok) {
          const msg =
            responseJson.description ||
            responseJson.message ||
            "Could not add to cart";
          alert(msg);
          return;
        }
        const cartContent = await (
          await fetch(`${window.Shopify.routes.root}cart.js`)
        ).json();
        cartContent["sections"] = responseJson["sections"] || {};
        document.documentElement.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: responseJson.items,
              cart: cartContent,
            },
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent,
            },
          })
        );
      } catch (err) {
        console.error(err);
        alert("Could not add to cart");
      } finally {
        btn.removeAttribute("disabled");
        btn.removeAttribute("aria-busy");
      }
    },
    false
  );
})();

// Cart drawer footer upsell: static products + complementary algo, dedupe, cap, dots
(function initCartDrawerUpsell() {
  const activeAlgoLoads = new WeakMap();
  const ITEM_SELECTOR = ".cart-drawer__upsell-item";
  const ALGO_FETCH_TIMEOUT_MS = 4000;

  function getUpsellItems(list) {
    return [...list.querySelectorAll(ITEM_SELECTOR)];
  }

  function getUpsellVisibleCards(wrap) {
    if (!wrap) return 2.5;

    const isMobile = window.matchMedia("(max-width: 699px)").matches;
    const raw = isMobile
      ? wrap.dataset.cartDrawerVisibleCardsMobile
      : wrap.dataset.cartDrawerVisibleCardsDesktop;
    const parsed = parseFloat(raw);

    if (Number.isFinite(parsed) && parsed > 0) return parsed;
    return isMobile ? 2.5 : 4;
  }

  function setUpsellLayoutReady(wrap, ready) {
    if (!wrap) return;
    wrap.classList.toggle("is-layout-ready", ready);
  }

  function setUpsellResolution(wrap, state) {
    if (!wrap || !["pending", "ready"].includes(state)) return;

    if (wrap.dataset.cartDrawerUpsellResolution !== state) {
      wrap.dataset.cartDrawerUpsellResolution = state;
    }

    const carousel = wrap.querySelector(".cart-drawer__upsell-carousel");
    if (carousel) {
      if (state === "pending" && !carousel.hasAttribute("inert")) {
        carousel.setAttribute("inert", "");
      } else if (state === "ready" && carousel.hasAttribute("inert")) {
        carousel.removeAttribute("inert");
      }
    }

    const panel = wrap.closest("[data-cart-drawer-upsell-panel]");
    const busy = state === "pending" ? "true" : "false";
    if (panel?.getAttribute("aria-busy") !== busy) {
      panel?.setAttribute("aria-busy", busy);
    }
  }

  function getAlgoSignature(host) {
    return [
      host.dataset.cartDrawerAlgoProductIds || "",
      host.dataset.cartDrawerAlgoDisplayLimit || "",
      host.dataset.cartDrawerAlgoFetchLimit || "",
      host.dataset.cartDrawerAlgoSectionId || "",
      window.Shopify?.routes?.root || "",
    ].join("|");
  }

  async function fetchAlgoRecommendations(url) {
    const controller = typeof AbortController === "function" ? new AbortController() : null;
    let timeoutId;

    const timeout = new Promise((_, reject) => {
      timeoutId = window.setTimeout(() => {
        controller?.abort();
        reject(new Error("Cart drawer recommendations timed out"));
      }, ALGO_FETCH_TIMEOUT_MS);
    });

    try {
      return await Promise.race([
        fetch(url, {
          priority: "low",
          ...(controller ? { signal: controller.signal } : {}),
        }),
        timeout,
      ]);
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  function sameUpsellHandles(host, items) {
    const current = getUpsellItems(host).map((item) => item.dataset.productHandle || "");
    const next = items.map((item) => item.dataset.productHandle || "");
    return current.length === next.length && current.every((handle, index) => handle === next[index]);
  }

  function syncUpsellCardWidths(carousel) {
    if (!carousel) return;

    const wrap = carousel.closest(".cart-drawer__upsell-carousel-wrap");
    const styles = getComputedStyle(wrap || carousel);
    const gap =
      parseFloat(styles.getPropertyValue("--cart-drawer-upsell-gap").trim()) || 5;
    const visibleCards = getUpsellVisibleCards(wrap);
    const insetStart =
      parseFloat(
        styles.getPropertyValue("--cart-drawer-upsell-inset-start").trim()
      ) || 0;
    const insetEnd =
      parseFloat(
        styles.getPropertyValue("--cart-drawer-upsell-inset-end").trim()
      ) || insetStart;
    const gapsInView = Math.max(0, Math.ceil(visibleCards) - 1);
    const viewportWidth = Math.max(0, carousel.clientWidth - insetStart - insetEnd);

    wrap?.style.setProperty(
      "--cart-drawer-upsell-visible-cards",
      String(visibleCards)
    );

    if (viewportWidth <= 0) {
      setUpsellLayoutReady(wrap, false);
      return;
    }

    const cardWidth = Math.max(
      0,
      (viewportWidth - gap * gapsInView) / visibleCards
    );
    carousel.style.setProperty(
      "--cart-drawer-upsell-card-width",
      `${cardWidth}px`
    );
    carousel.classList.toggle(
      "is-scrollable",
      carousel.scrollWidth > carousel.clientWidth + 1
    );
    setUpsellLayoutReady(wrap, cardWidth > 0);
  }

  function refreshUpsellCarouselLayout(
    carousel = document.querySelector("cart-drawer .cart-drawer__upsell-carousel")
  ) {
    if (!carousel) return;

    const wrap = carousel.closest(".cart-drawer__upsell-carousel-wrap");
    setUpsellLayoutReady(wrap, false);

    const run = () => {
      syncUpsellCardWidths(carousel);
      syncUpsellNavButtons(carousel);
    };

    run();
    requestAnimationFrame(() => {
      run();
      requestAnimationFrame(run);
    });
  }

  function prepareUpsellCarouselAfterFooterSwap() {
    const cartDrawer = document.querySelector("cart-drawer");
    const carousel = cartDrawer?.querySelector(".cart-drawer__upsell-carousel");
    if (!carousel) return;

    carousel._items = null;
    bindUpsellCarouselNav(carousel);
    refreshUpsellCarouselLayout(carousel);
    restoreUpsellPanelState();
  }

  function initCartDrawerFooterObserver() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer || cartDrawer.dataset.upsellFooterObserved === "true") return;

    const footer = cartDrawer.querySelector('[slot="footer"]');
    if (!footer) return;

    cartDrawer.dataset.upsellFooterObserved = "true";

    new MutationObserver((mutations) => {
      const footerChanged = mutations.some(
        (mutation) =>
          mutation.type === "childList" && mutation.target === footer
      );
      if (!footerChanged) return;

      queueMicrotask(prepareUpsellCarouselAfterFooterSwap);
    }).observe(footer, { childList: true });
  }

  function syncUpsellNavButtons(carousel) {
    if (!carousel) return;

    const wrap = carousel.closest(".cart-drawer__upsell-carousel-wrap");
    const prev = wrap?.querySelector(".cart-drawer__upsell-nav--prev");
    const next = wrap?.querySelector(".cart-drawer__upsell-nav--next");
    if (!prev || !next) return;

    const isMobile = window.matchMedia("(max-width: 699px)").matches;
    if (isMobile) {
      prev.hidden = true;
      next.hidden = true;
      return;
    }

    const isScrollable = carousel.scrollWidth > carousel.clientWidth + 1;
    const scrollLeft = Math.round(Math.abs(carousel.scrollLeft));
    const maxScroll = Math.round(carousel.scrollWidth - carousel.clientWidth);

    if (!isScrollable) {
      prev.hidden = true;
      next.hidden = true;
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    const atStart = scrollLeft <= 2;
    const atEnd = scrollLeft >= maxScroll - 2;

    prev.hidden = atStart;
    prev.disabled = atStart;
    next.hidden = atEnd;
    next.disabled = atEnd;
  }

  function bindUpsellCarouselNav(carousel) {
    if (!carousel || carousel.dataset.cartDrawerUpsellNavBound === "true") return;
    carousel.dataset.cartDrawerUpsellNavBound = "true";

    const wrap = carousel.closest(".cart-drawer__upsell-carousel-wrap");
    const prev = wrap?.querySelector(".cart-drawer__upsell-nav--prev");
    const next = wrap?.querySelector(".cart-drawer__upsell-nav--next");

    const onNavClick = (event, direction) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (direction === "prev" && typeof carousel.previous === "function") {
        carousel.previous();
      } else if (direction === "next" && typeof carousel.next === "function") {
        carousel.next();
      }

      syncUpsellNavButtons(carousel);
    };

    prev?.addEventListener(
      "click",
      (event) => onNavClick(event, "prev"),
      { capture: true }
    );
    next?.addEventListener(
      "click",
      (event) => onNavClick(event, "next"),
      { capture: true }
    );

    const onScroll = () => {
      syncUpsellNavButtons(carousel);
      const cartDrawer = carousel.closest("cart-drawer");
      if (cartDrawer) updateUpsellActiveDot(cartDrawer);
    };
    carousel.addEventListener("scroll", onScroll, { passive: true });
    carousel.addEventListener("carousel:change", onScroll);
    carousel.addEventListener("carousel:settle", onScroll);

    if (window.ResizeObserver) {
      const observer = new ResizeObserver(() => {
        syncUpsellCardWidths(carousel);
        syncUpsellNavButtons(carousel);
        // Page count (cards-per-page) changes across breakpoints — rebuild dots.
        const cartDrawer = carousel.closest("cart-drawer");
        if (cartDrawer) syncUpsellPageDots(cartDrawer);
      });
      observer.observe(carousel);
      const track = carousel.querySelector(".cart-drawer__upsell-track");
      if (track) observer.observe(track);
    }
  }

  // How many whole cards make up one "page" (peek fractions don't count).
  function getUpsellCardsPerPage(carousel) {
    const wrap = carousel?.closest(".cart-drawer__upsell-carousel-wrap");
    return Math.max(1, Math.floor(getUpsellVisibleCards(wrap) + 0.001));
  }

  // Page geometry derived from live layout. `step` (card width + gap) comes from
  // the offset delta of two items, so it stays correct regardless of inset/gap.
  function getUpsellPageMetrics(carousel, list) {
    const items = getUpsellItems(list);
    const cardsPerPage = getUpsellCardsPerPage(carousel);
    const pageCount = Math.ceil(items.length / cardsPerPage);

    let step = 0;
    if (items.length > 1) {
      step = items[1].offsetLeft - items[0].offsetLeft;
    } else if (items.length === 1) {
      step = items[0].offsetWidth;
    }

    return { items, cardsPerPage, pageCount, pageWidth: step * cardsPerPage };
  }

  function scrollUpsellToPage(cartDrawer, page) {
    const carousel = cartDrawer.querySelector(".cart-drawer__upsell-carousel");
    const list = cartDrawer.querySelector("[data-cart-drawer-recommendations-list]");
    if (!carousel || !list) return;

    const { pageWidth } = getUpsellPageMetrics(carousel, list);
    carousel.scrollTo({
      left: page * pageWidth,
      behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches
        ? "smooth"
        : "auto",
    });
  }

  function updateUpsellActiveDot(cartDrawer) {
    const dots = cartDrawer.querySelector("[data-cart-drawer-upsell-dots]");
    const carousel = cartDrawer.querySelector(".cart-drawer__upsell-carousel");
    const list = cartDrawer.querySelector("[data-cart-drawer-recommendations-list]");
    if (!dots || !carousel || !list) return;

    const buttons = [...dots.children];
    if (!buttons.length) return;

    const { pageWidth, pageCount } = getUpsellPageMetrics(carousel, list);
    const scrollLeft = Math.abs(carousel.scrollLeft);
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    let currentPage = pageWidth > 0 ? Math.round(scrollLeft / pageWidth) : 0;
    if (scrollLeft >= maxScroll - 2) currentPage = pageCount - 1;
    currentPage = Math.max(0, Math.min(pageCount - 1, currentPage));

    buttons.forEach((btn, index) =>
      btn.setAttribute("aria-current", index === currentPage ? "true" : "false")
    );
  }

  // One dot per page (not per item). Rebuilds only when the page count changes,
  // so scroll/resize just refresh the active dot without DOM churn.
  function syncUpsellPageDots(cartDrawer) {
    const existing = cartDrawer.querySelector("[data-cart-drawer-upsell-dots]");
    const list = cartDrawer.querySelector("[data-cart-drawer-recommendations-list]");
    const carousel = cartDrawer.querySelector(".cart-drawer__upsell-carousel");
    if (!existing || !list || !carousel) return;

    const goToLabel = existing.dataset.goToItemLabel || "Go to item %index%";
    const { pageCount } = getUpsellPageMetrics(carousel, list);
    const targetButtons = pageCount <= 1 ? 0 : pageCount;

    // A plain <div> (not <page-dots>) so the theme's per-item dot behaviour never binds.
    const isPlainDots = existing.tagName.toLowerCase() !== "page-dots";
    const currentButtons = existing.hidden ? 0 : existing.children.length;
    if (isPlainDots && currentButtons === targetButtons) {
      updateUpsellActiveDot(cartDrawer);
      return;
    }

    const newDots = document.createElement("div");
    newDots.className = existing.className;
    newDots.dataset.cartDrawerUpsellDots = "";
    newDots.dataset.goToItemLabel = goToLabel;

    if (pageCount <= 1) {
      newDots.hidden = true;
    } else {
      for (let page = 0; page < pageCount; page += 1) {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "tap-area";
        button.setAttribute("aria-current", page === 0 ? "true" : "false");

        const sr = document.createElement("span");
        sr.className = "sr-only";
        sr.textContent = goToLabel.replace("%index%", String(page + 1));
        button.appendChild(sr);
        button.addEventListener("click", () => scrollUpsellToPage(cartDrawer, page));
        newDots.appendChild(button);
      }
    }

    existing.replaceWith(newDots);
    updateUpsellActiveDot(cartDrawer);
  }

  function finalizeCartDrawerUpsell(root = document) {
    const cartDrawer = root.querySelector?.("cart-drawer");
    if (!cartDrawer) return;

    const panel = cartDrawer.querySelector("[data-cart-drawer-upsell-panel]");
    const list = cartDrawer.querySelector("[data-cart-drawer-recommendations-list]");
    const carousel = cartDrawer.querySelector(".cart-drawer__upsell-carousel");
    const carouselBlock = cartDrawer.querySelector("[data-cart-drawer-upsell-carousel-block]");

    if (!list) return;

    const limit = Math.max(
      1,
      parseInt(panel?.dataset.cartDrawerUpsellLimit || "4", 10)
    );
    const seenHandles = new Set();

    getUpsellItems(list).forEach((item) => {
      const handle = item.dataset.productHandle;
      if (!handle) return;

      if (seenHandles.has(handle)) {
        item.remove();
        return;
      }

      seenHandles.add(handle);
    });

    getUpsellItems(list)
      .slice(limit)
      .forEach((item) => item.remove());

    const itemCount = getUpsellItems(list).length;

    if (carouselBlock) {
      carouselBlock.hidden = itemCount === 0;
    }

    syncUpsellPageDots(cartDrawer);

    if (carousel) {
      carousel._items = null;
      bindUpsellCarouselNav(carousel);
      refreshUpsellCarouselLayout(carousel);
      if (typeof carousel.select === "function") {
        carousel.select(0, { animate: false, force: true });
      }
    }
  }

  async function loadCartDrawerAlgoRecommendations(root = document) {
    const cartDrawer = root.querySelector?.("cart-drawer");
    if (!cartDrawer || !window.Shopify?.routes?.root) return;

    const hosts = [...cartDrawer.querySelectorAll("[data-cart-drawer-algo-host]")];

    await Promise.all(
      hosts.map(async (host) => {
        // Complementary is the priority source and renders first; it must not skip
        // products that are also static picks (finalize removes the static duplicate).
        const signature = getAlgoSignature(host);
        if (host.dataset.cartDrawerAlgoResolvedKey === signature) return;

        const activeLoad = activeAlgoLoads.get(host);
        if (activeLoad?.signature === signature) {
          await activeLoad.promise;
          return;
        }

        const token = Symbol("cart-drawer-algo-load");
        const wrap = host.closest(".cart-drawer__upsell-carousel-wrap");
        const priorityCount = Math.max(
          0,
          parseInt(host.dataset.cartDrawerPriorityCount || "0", 10)
        );

        const productIds = (host.dataset.cartDrawerAlgoProductIds || "")
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean);

        const displayLimit = Math.max(
          0,
          parseInt(host.dataset.cartDrawerAlgoDisplayLimit || "2", 10)
        );
        setUpsellResolution(wrap, priorityCount >= displayLimit ? "ready" : "pending");

        if (priorityCount >= displayLimit) {
          host.hidden = true;
          host.dataset.cartDrawerAlgoResolvedKey = signature;
          finalizeCartDrawerUpsell(root);
          return;
        }

        const fetchLimit = Math.max(
          1,
          parseInt(host.dataset.cartDrawerAlgoFetchLimit || "2", 10)
        );
        const sectionId = host.dataset.cartDrawerAlgoSectionId || "cart-drawer-complementary";

        const promise = (async () => {
          // Let the WeakMap registration below become authoritative before even
          // an empty/no-limit request can reach the commit guard.
          await Promise.resolve();
          let mergedItems = [];

          if (productIds.length && displayLimit > 0) {
            // Fetch each cart product's complementary list, then round-robin interleave
            // them (A1, B1, A2, B2, …) so every cart product is represented before any
            // single list goes deep. Capped at displayLimit; theme picks fill any shortfall.
            const perProductItems = await Promise.all(
              productIds.map(async (productId) => {
                const url = `${Shopify.routes.root}recommendations/products?product_id=${encodeURIComponent(productId)}&limit=${fetchLimit}&section_id=${encodeURIComponent(sectionId)}&intent=complementary`;

                try {
                  const response = await fetchAlgoRecommendations(url);
                  if (!response.ok) return [];

                  const doc = new DOMParser().parseFromString(await response.text(), "text/html");
                  return [...doc.querySelectorAll(ITEM_SELECTOR)];
                } catch (_error) {
                  return [];
                }
              })
            );

            const seenHandles = new Set();
            const deepestList = perProductItems.reduce(
              (max, items) => Math.max(max, items.length),
              0
            );

            for (let index = 0; index < deepestList && mergedItems.length < displayLimit; index++) {
              for (const items of perProductItems) {
                if (mergedItems.length >= displayLimit) break;

                const item = items[index];
                if (!item) continue;

                const handle = item.dataset.productHandle;
                if (!handle || seenHandles.has(handle)) continue;

                seenHandles.add(handle);
                mergedItems.push(document.importNode(item, true));
              }
            }
          }

          const active = activeAlgoLoads.get(host);
          if (
            active?.token !== token ||
            !host.isConnected ||
            !cartDrawer.contains(host) ||
            getAlgoSignature(host) !== signature
          ) {
            return;
          }

          // Commit the complete curated result in one DOM write. Never clear the
          // visible host while the same list is being revalidated: that exposed the
          // static fallbacks for ~600 ms and caused the recorded product flash.
          if (!sameUpsellHandles(host, mergedItems)) {
            host.replaceChildren(...mergedItems);
          }

          const shouldHide = mergedItems.length === 0;
          if (host.hidden !== shouldHide) host.hidden = shouldHide;
          host.dataset.cartDrawerAlgoResolvedKey = signature;
        })();

        activeAlgoLoads.set(host, { signature, token, promise });

        try {
          await promise;
        } catch (_error) {
          // The server-rendered priority/static products remain a usable fallback.
        } finally {
          if (activeAlgoLoads.get(host)?.token === token) {
            activeAlgoLoads.delete(host);
          }

          if (host.isConnected && cartDrawer.contains(host)) {
            finalizeCartDrawerUpsell(root);
            setUpsellResolution(wrap, "ready");
          }
        }
      })
    );

    const currentHosts = [...cartDrawer.querySelectorAll("[data-cart-drawer-algo-host]")];
    const sameHostSet =
      currentHosts.length === hosts.length &&
      currentHosts.every((host, index) => host === hosts[index]);

    if (sameHostSet) {
      finalizeCartDrawerUpsell(root);
      currentHosts.forEach((host) => {
        if (host.dataset.cartDrawerAlgoResolvedKey === getAlgoSignature(host)) {
          setUpsellResolution(
            host.closest(".cart-drawer__upsell-carousel-wrap"),
            "ready"
          );
        }
      });
    }
  }

  async function refreshCartDrawerUpsell() {
    await loadCartDrawerAlgoRecommendations();
    restoreUpsellPanelState();
  }

  let refreshAfterCartDrawerSwapTimer;
  let upsellPanelWasOpen = false;
  let upsellPanelOpenedManually = false;

  function captureUpsellPanelState() {
    const toggle = document.querySelector("cart-drawer .cart-drawer__upsell-toggle");
    const body = document.querySelector("cart-drawer .cart-drawer__upsell-body");
    if (!toggle || !body) return;
    upsellPanelWasOpen =
      upsellPanelOpenedManually &&
      toggle.getAttribute("aria-expanded") === "true" &&
      !body.hidden;
  }

  function restoreUpsellPanelState() {
    const block = document.querySelector(
      "cart-drawer [data-cart-drawer-upsell-collapsible]"
    );
    const toggle = document.querySelector("cart-drawer .cart-drawer__upsell-toggle");
    const body = document.querySelector("cart-drawer .cart-drawer__upsell-body");
    if (!toggle || !body) return;

    const collapsedByDefault =
      block?.dataset.cartDrawerUpsellCollapsible === "true";

    // Black Weeks: with three pieces of jewellery in the cart (the free gift counts) the row folds
    // on every re-render, also after the customer opened it earlier, so the three lines and the
    // progress stay in view in the drawer (Peter 02/11/2026).
    if (
      collapsedByDefault &&
      document.documentElement.classList.contains("bf-insider-active")
    ) {
      upsellPanelWasOpen = false;
      upsellPanelOpenedManually = false;
    }

    if (upsellPanelWasOpen) {
      toggle.setAttribute("aria-expanded", "true");
      body.hidden = false;
      upsellPanelWasOpen = false;
      refreshUpsellCarouselLayout();
      return;
    }

    if (collapsedByDefault) {
      toggle.setAttribute("aria-expanded", "false");
      body.hidden = true;
    } else {
      toggle.setAttribute("aria-expanded", "true");
      body.hidden = false;
      refreshUpsellCarouselLayout();
    }
  }

  // ── Footer accordion: only one of the three boxes (upsell / gift / fordele)
  //    may be open at a time. Opening one collapses the others.
  function collapseUpsellBox() {
    const toggle = document.querySelector("cart-drawer .cart-drawer__upsell-toggle");
    const body = document.querySelector("cart-drawer .cart-drawer__upsell-body");
    if (!toggle || !body) return;
    if (toggle.getAttribute("aria-expanded") === "true") {
      toggle.setAttribute("aria-expanded", "false");
      body.hidden = true;
      upsellPanelWasOpen = false;
      upsellPanelOpenedManually = false;
    }
  }

  function collapseGiftBox() {
    const cb = document.querySelector("cart-drawer .cart-drawer__gift-checkbox");
    if (cb && cb.checked) cb.checked = false;
  }

  function collapseFordeleBox() {
    document.querySelector("cart-drawer cart-discount")?.closePanel?.();
  }

  document.addEventListener("click", (event) => {
    // Click the chevron OR anywhere on the header row (collapsible boxes only).
    const chevron = event.target.closest(".cart-drawer__upsell-toggle");
    const header = event.target.closest(".cart-drawer__upsell-header");
    const trigger = chevron || header;
    if (!trigger || !trigger.closest("cart-drawer")) return;

    const block = trigger.closest("[data-cart-drawer-upsell-carousel-block]");
    const toggle = block?.querySelector(".cart-drawer__upsell-toggle");
    if (!toggle) return;

    const bodyId = toggle.getAttribute("aria-controls");
    const body = bodyId ? document.getElementById(bodyId) : null;
    if (!body) return;

    const expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", expanded ? "false" : "true");
    body.hidden = expanded;
    upsellPanelWasOpen = !expanded;
    upsellPanelOpenedManually = !expanded;

    if (!expanded) {
      collapseGiftBox();
      collapseFordeleBox();
      refreshUpsellCarouselLayout();
    }
  });

  // Gift box opened (checkbox ticked) → collapse the other two.
  document.addEventListener("change", (event) => {
    const cb = event.target.closest?.(".cart-drawer__gift-checkbox");
    if (!cb || !cb.closest("cart-drawer")) return;
    if (cb.checked) {
      collapseUpsellBox();
      collapseFordeleBox();
    }
  });

  // Fordele panel opened → collapse the other two. Our delegated listener runs
  // after <cart-discount>'s own toggle handler, so aria-expanded is already set.
  document.addEventListener("click", (event) => {
    const toggle = event.target.closest?.(".cart-discount__toggle");
    if (!toggle || !toggle.closest("cart-drawer")) return;
    if (toggle.getAttribute("aria-expanded") === "true") {
      collapseUpsellBox();
      collapseGiftBox();
    }
  });

  document.addEventListener("cart:refresh", captureUpsellPanelState, true);
  document.addEventListener("cart:change", captureUpsellPanelState, true);

  document.addEventListener("cart-drawer:updated", () => {
    clearTimeout(refreshAfterCartDrawerSwapTimer);
    refreshCartDrawerUpsell();
  });
  window.addEventListener("resize", () => refreshUpsellCarouselLayout());
  document.addEventListener("DOMContentLoaded", () => {
    initCartDrawerFooterObserver();
    refreshCartDrawerUpsell();
  });
  window.addEventListener("welcome-discount:code-changed", refreshCartDrawerUpsell);
  document.addEventListener("cart:change", () => {
    clearTimeout(refreshAfterCartDrawerSwapTimer);
    refreshAfterCartDrawerSwapTimer = window.setTimeout(refreshCartDrawerUpsell, 2000);
  });
  document.addEventListener("cart:refresh", () => {
    clearTimeout(refreshAfterCartDrawerSwapTimer);
    refreshAfterCartDrawerSwapTimer = window.setTimeout(refreshCartDrawerUpsell, 2000);
  });

  // ── The free-shipping progress isn't part of the partial cart:refresh update,
  //    so applying/removing a discount code leaves its "Nog €X" text and bar fill
  //    at the pre-discount amount. Re-render just the shipping panel from the
  //    server (which calculates it correctly, discounts included).
  let shippingPanelRefreshing = false;
  async function refreshShippingPanel() {
    if (shippingPanelRefreshing) return;
    const drawer = document.querySelector("cart-drawer");
    const section = drawer?.closest('[id^="shopify-section-"]');
    if (!section || !drawer.querySelector(".cart-drawer__shipping-panel")) return;
    shippingPanelRefreshing = true;
    try {
      const sid = section.id.replace("shopify-section-", "");
      const html = await fetch(
        `${location.pathname}?section_id=${encodeURIComponent(sid)}`,
        { cache: "no-store" }
      ).then((r) => r.text());
      const fresh = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".cart-drawer__shipping-panel");
      const current = drawer.querySelector(".cart-drawer__shipping-panel");
      if (fresh && current) current.replaceWith(fresh);
    } catch (e) {
      /* leave the existing panel in place on failure */
    } finally {
      shippingPanelRefreshing = false;
    }
  }
  document.addEventListener("cart:refresh", refreshShippingPanel);
})();

// ── PDP "Fuldend looket" reco carousel: one dot per PAGE (like the cart upsell),
//    replacing the theme's per-item <page-dots>.
(function () {
  function visibleCards(block) {
    const isMobile = window.matchMedia("(max-width: 699px)").matches;
    const raw = getComputedStyle(block).getPropertyValue(
      isMobile ? "--pdp-reco-cards-mobile" : "--pdp-reco-cards-desktop"
    );
    const parsed = parseFloat(raw);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
    return isMobile ? 2.5 : 3;
  }

  function metrics(block) {
    const carousel = block.querySelector(".pdp-reco__carousel");
    const cards = [...block.querySelectorAll(".pdp-reco__card")];
    if (!carousel || cards.length === 0) return null;
    const cardsPerPage = Math.max(1, Math.floor(visibleCards(block) + 0.001));
    const pageCount = Math.ceil(cards.length / cardsPerPage);
    const step =
      cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
    return { carousel, cards, cardsPerPage, pageCount, pageWidth: step * cardsPerPage };
  }

  function updateActive(block) {
    const dots = block.querySelector(".pdp-reco__dots");
    const m = metrics(block);
    if (!dots || !m) return;
    const buttons = [...dots.children];
    if (!buttons.length) return;
    const scrollLeft = Math.abs(m.carousel.scrollLeft);
    const maxScroll = m.carousel.scrollWidth - m.carousel.clientWidth;
    let page = m.pageWidth > 0 ? Math.round(scrollLeft / m.pageWidth) : 0;
    if (scrollLeft >= maxScroll - 2) page = m.pageCount - 1;
    page = Math.max(0, Math.min(m.pageCount - 1, page));
    buttons.forEach((b, i) =>
      b.setAttribute("aria-current", i === page ? "true" : "false")
    );
  }

  // Rebuild the dots only when the page count changes; otherwise just refresh
  // the active dot (no DOM churn on scroll/resize).
  function build(block) {
    const existing = block.querySelector(".pdp-reco__dots");
    const m = metrics(block);
    if (!existing || !m) return;

    const goToLabel = existing.dataset.goToItemLabel || "Go to item %index%";
    const targetCount = m.pageCount <= 1 ? 0 : m.pageCount;
    const isPlain = existing.tagName.toLowerCase() !== "page-dots";
    const currentCount = existing.hidden ? 0 : existing.children.length;
    if (isPlain && currentCount === targetCount) {
      updateActive(block);
      return;
    }

    // Plain <div> (not <page-dots>) so the theme's per-item dot behaviour never binds.
    const dots = document.createElement("div");
    dots.className = existing.className;
    dots.dataset.goToItemLabel = goToLabel;
    if (m.pageCount <= 1) {
      dots.hidden = true;
    } else {
      for (let p = 0; p < m.pageCount; p += 1) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "tap-area";
        btn.setAttribute("aria-current", p === 0 ? "true" : "false");
        const sr = document.createElement("span");
        sr.className = "sr-only";
        sr.textContent = goToLabel.replace("%index%", String(p + 1));
        btn.appendChild(sr);
        btn.addEventListener("click", () => {
          const mm = metrics(block);
          if (!mm) return;
          mm.carousel.scrollTo({
            left: p * mm.pageWidth,
            behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches
              ? "smooth"
              : "auto",
          });
        });
        dots.appendChild(btn);
      }
    }
    existing.replaceWith(dots);
    updateActive(block);
  }

  function initBlock(block) {
    build(block);
    const carousel = block.querySelector(".pdp-reco__carousel");
    if (carousel && !carousel.dataset.pdpRecoDotsBound) {
      carousel.dataset.pdpRecoDotsBound = "1";
      let raf;
      carousel.addEventListener(
        "scroll",
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => updateActive(block));
        },
        { passive: true }
      );
    }
  }

  function initWithin(root) {
    if (!(root instanceof Element)) return;
    if (root.matches(".pdp-reco")) initBlock(root);
    root.querySelectorAll(".pdp-reco").forEach(initBlock);
  }

  function initAll() {
    document.querySelectorAll(".pdp-reco").forEach(initBlock);
  }

  // Shopify inserts the recommendation block after a low-priority fetch. It can
  // arrive after both DOMContentLoaded and window.load, so those events alone
  // leave the server-rendered one-dot-per-product controls in place. Observe the
  // actual insertion and convert the dots in the same render turn.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(initWithin);
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  window.addEventListener("load", initAll);
  window.addEventListener("resize", () =>
    document.querySelectorAll(".pdp-reco").forEach(build)
  );
})();
